import { render, staticRenderFns } from "./SocialRewardsDescription.vue?vue&type=template&id=78212600&scoped=true&"
import script from "./SocialRewardsDescription.vue?vue&type=script&lang=ts&"
export * from "./SocialRewardsDescription.vue?vue&type=script&lang=ts&"
import style0 from "./SocialRewardsDescription.vue?vue&type=style&index=0&id=78212600&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78212600",
  null
  
)

export default component.exports